import moment from 'moment';
import * as types from './types';
import en from '../../i18n/en';
import es from '../../i18n/es';
import langStrings from '../../i18n';
import API from '../../api';

const setEn = (userId) => (dispatch) => {
  langStrings.setLanguage('en');
  moment.locale('en');
  dispatch({ type: types.SET_EN, lang: en });
  if (userId) API.put(`/users/${userId}/language`, { language: 'en' });
};

const setEs = (userId) => (dispatch) => {
  langStrings.setLanguage('es');
  moment.locale('es');
  dispatch({ type: types.SET_ES, lang: es });
  if (userId) API.put(`/users/${userId}/language`, { language: 'es' });
};
export { setEn, setEs };
